import pick from 'lodash/pick';
import Cookies from 'js-cookie';
import queryString from 'query-string';

const campaignParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
];

if (!Cookies.get('userTracker')) {

    const userTracker = {};
    const searchParams = queryString.parse(location.search);

    userTracker.campaignParams = pick(searchParams, campaignParams);

    Cookies.set('userTracker', userTracker, {
        domain: window.cookieDomain,
        secure: true,
    });
}



// WEBPACK FOOTER //
// ./app/scripts/components/user-tracker.js